import React, { useState } from 'react';
import { Formik, Form as FormikForm } from 'formik';
import Styles from './AIPoweredBrief.module.scss';
import { foundationSchema } from 'schemas/briefSchemas';
import BSButton from 'Components/Button/BSButton';
import FoundationFields from './FoundationFields';
import BriefForm from '../BriefForm';
import Spinner from 'Components/Spinner/Spinner';
import useAiPoweredBrief from 'hooks/useAiPoweredBrief';
import { ProgressBar } from 'react-bootstrap';
import { extractSupportingDocuments } from 'services/projectService';

const AIPoweredBrief = ({
  initialValues,
  priorityOptions,
  userOptions,
  stateOptions,
  isProjectView,
  teamOptions,
  setSelectedProject,
  documentOptions,
  onSubmit,
  onHide,
  setSearchDocs,
  action,
}) => {
  // Supporting documents state
  const [supportingFiles, setSupportingFiles] = useState([]);
  const [supportingContent, setSupportingContent] = useState('');
  const [isExtracting, setIsExtracting] = useState(false);
  const [extractionProgress, setExtractionProgress] = useState(0);
  const [uploadErrors, setUploadErrors] = useState([]);

  // Handler for supporting documents upload
  const handleSupportingFilesChange = async (files) => {
    setSupportingFiles(files);
    setUploadErrors([]);

    if (files.length > 0) {
      setIsExtracting(true);
      setExtractionProgress(0);

      const progressInterval = setInterval(() => {
        setExtractionProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return prev;
          }
          return prev + 10;
        });
      }, 200);

      try {
        const response = await extractSupportingDocuments(files);
        clearInterval(progressInterval);
        setExtractionProgress(100);
        setSupportingContent(response?.data?.data || '');
      } catch (error) {
        clearInterval(progressInterval);
        setUploadErrors(['Failed to extract content from files. Please try again.']);
        setSupportingContent('');
      } finally {
        setIsExtracting(false);
      }
    } else {
      setSupportingContent('');
    }
  };

  const {
    setupStep,
    formFields,
    handleFormFieldsChange,
    generateBrief,
    aiBrief,
    isGeneratingAiBrief,
  } = useAiPoweredBrief(initialValues, supportingContent);

  return (
    <>
      {setupStep === 0 && (
        <Formik
          onSubmit={generateBrief}
          initialValues={formFields}
          validationSchema={foundationSchema}
          validateOnMount={true}
        >
          {({ values, setFieldValue }) => {
            const { content_type, goals } = values || {};
            return (
              <FormikForm className={Styles.Container}>
                <FoundationFields
                  content_type={content_type}
                  goals={goals}
                  handleFormFieldsChange={handleFormFieldsChange}
                  setFieldValue={setFieldValue}
                  supportingFiles={supportingFiles}
                  setSupportingFiles={handleSupportingFilesChange}
                  supportingContent={supportingContent}
                  isExtracting={isExtracting}
                  extractionProgress={extractionProgress}
                  uploadErrors={uploadErrors}
                  setUploadErrors={setUploadErrors}
                />

                <div className="d-flex justify-content-end drawer-footer">
                  <BSButton
                    classList={`button secondary_btn ${Styles.Container_NextButton}`}
                    variant="light"
                    ButtonText="Generate Brief"
                    onClick={generateBrief}
                    disabled={!(formFields.content_type || supportingContent)}
                  />
                </div>
              </FormikForm>
            );
          }}
        </Formik>
      )}
      {action === 'create' && (
        <ProgressBar now={66} className="drawer-progress-bar" />
      )}
      {setupStep === 1 &&
        (isGeneratingAiBrief ? (
          <Spinner
            className={Styles.Container_KeywordsContainer_KeywordsSpinner}
            text="Generating Brief..."
          />
        ) : (
          <BriefForm
            initialValues={aiBrief}
            priorityOptions={priorityOptions}
            userOptions={userOptions}
            stateOptions={stateOptions}
            teamOptions={teamOptions}
            documentOptions={documentOptions}
            isProjectView={isProjectView}
            setSelectedProject={setSelectedProject}
            buttonTitle={'Add to Plan'}
            action={action}
            onSubmit={onSubmit}
            onHide={onHide}
            setSearchDocs={setSearchDocs}
          />
        ))}
    </>
  );
};

export default AIPoweredBrief;
